// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import { translations, translateFunc } from '../shared/localize'
import type {
  OptionType,
  GroupedOptionType,
  AutomatedRule,
  ConditionType,
  ActionType
} from './types'

import Form from './AutomatedRulesEdit/Form'
import postJson from '../services/postJson'
import scrollToTop from '../shared/scrollToTop'

type Errors = Array<string>

type Props = {|
  locale: string,
  currentRule: AutomatedRule,
  audienceOptions: Array<GroupedOptionType>,
  providerOptions: Array<OptionType>,
  actionOptions: Array<OptionType>,
  conditionOptions: Array<OptionType>
|}

type State = {|
  isLoading: boolean,
  nameErrors: Errors,
  audienceIdsErrors: Errors,
  providersErrors: Errors,
  conditionsErrors: Array<Object>,
  actionErrors: Object,
  name: string,
  audienceIds: Array<number>,
  providers: Array<string>,
  conditions: Array<ConditionType>,
  action: ActionType
|}

const AutomatedRulePath = '/api/v1/automated_rules'

const EmptyAction: ActionType = {
  action_type: '',
  check_frequency: 'once_per_hour',
  apply_frequency: 'once_per_hour',
  amount_type: 'sum'
}

export default class AutomatedRulesEdit extends Component<Props, State> {
  table: any
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.automated_rules_table, { locale: props.locale })

    this.state = {
      isLoading: false,
      nameErrors: [],
      audienceIdsErrors: [],
      providersErrors: [],
      conditionsErrors: [],
      actionErrors: [],
      name: props.currentRule.name || '',
      audienceIds: props.currentRule.audience_ids || [],
      providers: props.currentRule.providers || [],
      conditions: props.currentRule.conditions || [],
      action: props.currentRule.action || EmptyAction
    }
  }

  render() {
    let props = this.props
    let state = this.state

    return (
      <div>
        <div style={{ height: '50px' }} />
        <Form
          t={this.t}
          id={props.currentRule.id}
          name={state.name}
          audienceIds={state.audienceIds}
          providers={state.providers}
          conditions={state.conditions}
          action={state.action}
          audienceOptions={props.audienceOptions}
          providerOptions={props.providerOptions}
          actionOptions={props.actionOptions}
          conditionOptions={props.conditionOptions}
          nameErrors={state.nameErrors}
          audienceIdsErrors={state.audienceIdsErrors}
          providersErrors={state.providersErrors}
          conditionsErrors={state.conditionsErrors}
          actionErrors={state.actionErrors}
          isLoading={state.isLoading}
          onClearErrors={(clearedErrors) => this.setState(clearedErrors)}
          onChange={(val) => this.setState(val)}
          onApply={() => (props.currentRule.id ? this.updateRule() : this.createRule())}
        />
      </div>
    )
  }

  providerName(provider: string) {
    let index = _.findIndex(this.props.providerOptions, { id: provider })

    return index === -1 ? provider : this.props.providerOptions[index].name
  }

  renderAudiencesNames(ids: Array<string>) {
    return (
      <div>
        {ids.map((id, index) => (
          <div key={index}>{this.audienceName(id)}</div>
        ))}
      </div>
    )
  }

  audienceName(id: string) {
    let audiences = _.flatten(
      _.map(this.props.audienceOptions, (groupedOptions) => {
        return groupedOptions.options
      })
    )
    let index = _.findIndex(audiences, { id: parseInt(id) })
    return index === -1 ? id : audiences[index].name
  }

  data() {
    const { name, audienceIds, providers, conditions, action } = this.state
    return {
      data: {
        name: name,
        audience_ids: audienceIds,
        providers: providers,
        conditions: this.parsedConditions(conditions),
        action: this.parsedAction(action)
      }
    }
  }

  parsedConditions(conditions: Array<ConditionType>): Array<ConditionType> {
    return _.map(conditions, (condition) => {
      return { ...condition, value: parseFloat(condition.value) }
    })
  }

  parsedAction(action: ActionType): ActionType {
    return {
      ...action,
      amount: parseFloat(action.amount),
      edge_amount: parseFloat(action.edge_amount)
    }
  }

  createRule() {
    this.setState({ isLoading: true })
    postJson(AutomatedRulePath, this.data())
      .done((response: Object) => {
        this.handleDoneResponse(response)
      })
      .fail(({ responseJSON }: any) => {
        const responseObject = responseJSON.message
        this.handleErrorResponse(responseObject)
      })
      .always(() => this.setState({ isLoading: false }))
  }

  updateRule() {
    this.setState({ isLoading: true })
    let url = AutomatedRulePath + '/' + this.props.currentRule.id
    postJson(url, this.data())
      .done((response: Object) => {
        this.handleDoneResponse(response)
      })
      .fail(({ responseJSON }: any) => {
        const responseObject = responseJSON.message
        this.handleErrorResponse(responseObject)
        scrollToTop()
      })
      .always(() => this.setState({ isLoading: false }))
  }

  handleDoneResponse(response: Object) {
    if (response.success) {
      window.location = '/automated_rules'
    } else {
      window.alert('Process error!')
    }
  }

  handleErrorResponse(message: Object) {
    this.setState({
      nameErrors: message.name || [],
      audienceIdsErrors: message.audience_ids || [],
      providersErrors: message.providers || [],
      conditionsErrors: (message.conditions && message.conditions[0]) || [],
      actionErrors: message.action || []
    })
  }
}
